import { render, staticRenderFns } from "./IconHalt.vue?vue&type=template&id=a2af9dbc"
import script from "./IconHalt.vue?vue&type=script&lang=js"
export * from "./IconHalt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports